import useDate from '@/services/utils/day';

const pdfHeaderFooter = () => {
    const { formatDate } = useDate();

    const getHeader = (company) => {
        return {
            margin: [ 25, 25, 25, 10 ],
            columns: [
                {
                    alignment: 'left',
                    image: company.logo64,
                    maxHeight: 60
                },

                {
                    alignment: 'right',
                    stack: [
                        (company.name) ? company.name : '',
                        (company.address) ? 'Address: ' + company.address : '',
                        (company.phone) ? 'Phone: ' + company.phone : '',
                        (company.email) ? 'E-mail: ' + company.email : '',
                        (company.vat_no) ? 'VAT Reg No: ' + company.vat_no : '',
                    ]
                }
            ]
        }
    }

    const getFooter = (userName, qrcode) => {
        return {
            margin: [ 25, 0 ],
            columns: [
                {
                    columns: [
                        {
                            svg: qrcode
                        },

                        {
                            width: '90%',
                            alignment: 'left',
                            text: 'N.B: This is a system generated documents and requires no manual signature.',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        }
                    ]
                },

                {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },
                        {
                            text: userName
                        },
                        {
                            text: formatDate(new Date())
                        }
                    ]
                }
            ]
        }
    }

    return {
        getHeader, 
        getFooter
    }
}

export default pdfHeaderFooter;
